const categoryCards = [
  {
    name: 'Shoes',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20sneakers%20and%20leather%20shoes%20displayed%20on%20a%20smooth%20terrazzo%20surface%20with%20morning%20sunlight%2C%20minimalist%20product%20photography%20with%20cream%20backdrop%2C%20editorial%20composition%20featuring%20modern%20footwear%20designs%20in%20warm%20terracotta%20and%20sand%20tones%2C%20gentle%20shadows%20and%20refined%20styling&width=800&height=800&seq=cat-v3-shoes&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    name: 'Hoodies/Sweaters',
    image: 'https://readdy.ai/api/search-image?query=Cashmere%20and%20cotton%20hoodies%20in%20neutral%20earth%20colors%20artfully%20draped%20on%20a%20minimalist%20wooden%20chair%2C%20soft%20afternoon%20window%20light%20highlighting%20textile%20texture%2C%20cream%20wall%20background%20with%20subtle%20shadows%2C%20cozy%20luxury%20casual%20fashion%20editorial%20style%20with%20warm%20amber%20undertones&width=800&height=800&seq=cat-v3-hoodies&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
  },
  {
    name: 'T-Shirts',
    image: 'https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20t-shirts%20in%20warm%20neutral%20palette%20neatly%20stacked%20on%20a%20rattan%20shelf%2C%20golden%20hour%20sunlight%20creating%20soft%20highlights%2C%20minimalist%20flat%20lay%20photography%20with%20natural%20linen%20backdrop%2C%20effortless%20everyday%20style%20with%20refined%20aesthetic&width=800&height=800&seq=cat-v3-tshirts&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
  },
  {
    name: 'Jackets',
    image: 'https://readdy.ai/api/search-image?query=Designer%20denim%20and%20bomber%20jackets%20hanging%20on%20a%20sleek%20matte%20black%20rack%20against%20a%20textured%20cream%20wall%2C%20directional%20studio%20lighting%20with%20dramatic%20yet%20soft%20shadows%2C%20contemporary%20fashion%20editorial%20photography%20with%20warm%20earthy%20accents&width=800&height=800&seq=cat-v3-jackets&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
  },
  {
    name: 'Pants/Shorts',
    image: 'https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20and%20chino%20shorts%20in%20sand%20and%20olive%20tones%20displayed%20on%20a%20minimalist%20clothing%20form%2C%20soft%20ambient%20studio%20light%20with%20clean%20background%2C%20modern%20menswear%20product%20photography%20emphasizing%20fabric%20drape%2C%20warm%20neutral%20aesthetic&width=800&height=800&seq=cat-v3-pants&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
  },
  {
    name: 'Headwear',
    image: 'https://readdy.ai/api/search-image?query=Premium%20baseball%20caps%20and%20wool%20beanies%20in%20muted%20autumn%20colors%20arranged%20on%20a%20concrete%20surface%2C%20natural%20skylight%20illumination%2C%20minimalist%20accessories%20photography%20with%20warm%20taupe%20backdrop%2C%20contemporary%20streetwear%20editorial%20with%20subtle%20texture%20details&width=800&height=800&seq=cat-v3-headwear&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
  },
  {
    name: 'Sets',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20fashion%20sets%20in%20monochrome%20beige%20displayed%20on%20sleek%20minimalist%20mannequins%2C%20soft%20studio%20lighting%20with%20warm%20undertones%2C%20modern%20retail%20display%20photography%20with%20clean%20composition%2C%20elegant%20contemporary%20fashion%20aesthetic&width=800&height=800&seq=cat-v3-sets&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
  },
  {
    name: 'Underwear/Underpants',
    image: 'https://readdy.ai/api/search-image?query=Soft%20bamboo%20fiber%20underwear%20essentials%20in%20warm%20cream%20and%20blush%20tones%20folded%20on%20a%20smooth%20marble%20surface%2C%20diffused%20natural%20light%20from%20sheer%20curtains%2C%20minimalist%20intimate%20photography%20with%20fresh%20clean%20aesthetic%2C%20understated%20luxury%20composition&width=800&height=800&seq=cat-v3-underwear&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
  },
  {
    name: 'Jersey',
    image: 'https://readdy.ai/api/search-image?query=Athletic%20performance%20jerseys%20in%20rich%20burgundy%20and%20forest%20green%20displayed%20on%20a%20metal%20hanger%2C%20dramatic%20rim%20lighting%20highlighting%20moisture-wicking%20fabric%20texture%2C%20sportswear%20editorial%20photography%20with%20dark%20warm%20background%2C%20dynamic%20yet%20refined%20composition&width=800&height=800&seq=cat-v3-jersey&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
  },
  {
    name: 'Accessories',
    image: 'https://readdy.ai/api/search-image?query=Designer%20watches%20rings%20and%20bracelets%20elegantly%20scattered%20on%20a%20travertine%20surface%2C%20golden%20hour%20sunlight%20creating%20sparkling%20reflections%2C%20luxury%20jewelry%20photography%20with%20warm%20neutral%20backdrop%2C%20refined%20editorial%20composition%20with%20depth%20and%20texture&width=800&height=800&seq=cat-v3-accessories&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
  },
  {
    name: 'Bags',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpacks%20and%20canvas%20tote%20bags%20displayed%20on%20a%20rustic%20wooden%20bench%2C%20soft%20morning%20light%20streaming%20through%20industrial%20windows%2C%20modern%20accessories%20photography%20with%20warm%20brick%20tones%2C%20thoughtful%20composition%20featuring%20texture%20contrast&width=800&height=800&seq=cat-v3-bags&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
  },
  {
    name: 'Belts',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20in%20cognac%20and%20chocolate%20brown%20tones%20gracefully%20curved%20on%20a%20suede%20mat%2C%20warm%20directional%20studio%20light%20emphasizing%20stitching%20detail%2C%20artisan%20product%20photography%20with%20cream%20backdrop%2C%20refined%20craftsmanship%20aesthetic&width=800&height=800&seq=cat-v3-belts&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
  },
  {
    name: 'Perfumes',
    image: 'https://readdy.ai/api/search-image?query=Artisan%20fragrance%20bottles%20with%20minimalist%20glass%20designs%20arranged%20on%20a%20polished%20stone%20surface%2C%20soft%20candlelight%20reflections%20creating%20warm%20ambiance%2C%20luxury%20perfume%20editorial%20photography%20with%20rich%20amber%20background%2C%20sophisticated%20composition%20with%20dried%20botanical%20accents&width=800&height=800&seq=cat-v3-perfumes&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
  },
  {
    name: 'OtherStuff',
    image: 'https://readdy.ai/api/search-image?query=Eclectic%20lifestyle%20essentials%20including%20notebooks%20sunglasses%20and%20small%20accessories%20artfully%20arranged%20on%20a%20textured%20clay%20surface%2C%20soft%20natural%20daylight%20overhead%2C%20minimalist%20flat%20lay%20with%20warm%20terracotta%20and%20cream%20palette%2C%20creative%20bohemian%20aesthetic&width=800&height=800&seq=cat-v3-other&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
  },
];

export default function CategoryGrid() {
  const groups = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11],
    [12, 13],
  ];

  return (
    <section className="w-full py-14 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Shop by Category
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Browse our curated collection of <strong>LitBuy spreadsheet</strong> shopping categories. Every category connects you directly to the best deals on KasPreadsheet.
          </p>
        </div>

        {groups.map((group, groupIdx) => (
          <div
            key={groupIdx}
            className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 ${
              groupIdx < groups.length - 1 ? 'mb-5 md:mb-6' : ''
            }`}
          >
            {group.map((catIdx) => {
              const cat = categoryCards[catIdx];
              return (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group relative w-full aspect-square rounded-2xl overflow-hidden cursor-pointer"
                >
                  <img
                    src={cat.image}
                    alt={`${cat.name} - LitBuy Spreadsheet Shopping Category`}
                    title={`Shop ${cat.name} via LitBuy Spreadsheet`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                  <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <p className="text-xl md:text-2xl font-heading font-bold text-white drop-shadow-md">
                      {cat.name}
                    </p>
                    <p className="text-xs md:text-sm text-white/70 mt-1 drop-shadow-sm">
                      Shop Now &rarr;
                    </p>
                  </div>
                </a>
              );
            })}
            {groupIdx === groups.length - 1 && (
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group relative w-full aspect-square rounded-2xl overflow-hidden cursor-pointer bg-gradient-to-br from-primary-400/30 via-secondary-300/40 to-primary-200/50"
              >
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-white/80 mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-arrow-right-line text-2xl md:text-3xl text-primary-500"></i>
                  </div>
                  <p className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    See All Deals
                  </p>
                  <p className="text-xs md:text-sm text-foreground-600 mt-1">
                    Browse everything &rarr;
                  </p>
                </div>
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}